module.exports = __webpack_public_path__ + "img/add-to-wallet-passes-logo.png";